class CollectionHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.elementOffsetTop = this.offsetTop - 60
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop

    this.classList.toggle(
      this.dataset.stickyClass,
      scrollPosition >= this.elementOffsetTop,
    )
  }
}

if (!customElements.get('collection-header')) {
  customElements.define('collection-header', CollectionHeader, {
    extends: 'header',
  })
}
